import { useState, useCallback, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Input, Form, Spin } from 'antd';
import {
  getContactShareOrganization,
  validateContactShareAuth,
} from 'services/api';
import BrokersafeLogo from 'assets/icons/brokersafe_logo.svg';
import { Root } from './styles';
import { Organziation } from './types';

const ContactShare = () => {
  const navigate = useNavigate();
  const [hasError, setError] = useState(false);
  const [searchParams] = useSearchParams();
  const guid = searchParams.get('guid');
  const [organziation, setOrganization] = useState<Organziation>();
  const [isSubmitting, setSubmitting] = useState(false);

  const getOrganization = useCallback(async () => {
    if (!guid) {
      return;
    }

    try {
      const organziationRes = await getContactShareOrganization(guid);
      if (organziationRes.Organization_Name) {
        setOrganization(organziationRes);
      }
    } catch (error) {}
  }, [guid]);

  useEffect(() => {
    getOrganization();
  }, [getOrganization]);

  const onFinish = async (values: any) => {
    const payload = {
      guid,
      phone_number_last_digits: values.phone,
    };
    setSubmitting(true);
    try {
      const authRes = await validateContactShareAuth(payload);
      const entirePhoneNumber = authRes.Customer_Phone;
      if (entirePhoneNumber.slice(-4) !== values.phone) {
        setError(true);
        setSubmitting(false);
        return;
      }
      const requestPK = authRes.Dwolla_Customer_Organization_Request_PK;
      navigate(`/contact/share_request?guid=${guid}&request=${requestPK}`);

      setSubmitting(false);
    } catch (error) {
      setError(true);
      setSubmitting(false);
    }
  };

  return (
    <Root>
      <div className="container">
        <header className="header">
          {organziation?.Organization_Logo_URL && (
            <img
              className="logo-wrapper"
              src={organziation?.Organization_Logo_URL}
              style={{ width: '100%', height: '100%' }}
              alt="brokersafe-logo"
            />
          )}
        </header>

        <Spin
          style={{ width: '100%', marginTop: 150 }}
          tip="One moment while we complete the verify."
          size="large"
          spinning={isSubmitting}
        >
          <p>
            In order to verify your identify, enter the last 4 digits of your
            mobile phone number.
          </p>
          <Form layout="vertical" name="nest-messages" onFinish={onFinish}>
            <Form.Item
              name="phone"
              className="phone-wrapper"
              rules={[
                {
                  required: true,
                  message: 'Required',
                },
                {
                  pattern: /^[0-9]{4}$/,
                  message: 'Invalid format',
                },
              ]}
            >
              <Input
                onChange={(e) => {
                  setError(false);
                  if (e.target.value.length === 4) {
                    onFinish({ phone: e.target.value });
                  }
                }}
              />
            </Form.Item>
          </Form>
          {(hasError || !guid) && (
            <p className="error">
              We were unable to validate the information provided.
            </p>
          )}
        </Spin>
      </div>
      <footer>
        <div className="tifle-logo-wrapper">
          <div>Powered By</div>
          <img src={BrokersafeLogo} alt="brokersafe-logo" />
        </div>
      </footer>
    </Root>
  );
};

export default ContactShare;
